<kendo-dropdownlist [data]="internalData" (valueChange)="onChange($event)" [value]="selectedValue"
  [valuePrimitive]="true" [textField]="textField" [valueField]="valueField" [listHeight]="dropdownListHeight"
  [popupSettings]="{ width: 225 }" [attr.aria-label]="ariaLabel">
</kendo-dropdownlist>